<template functionnal>
  <div class="template pb-4">
    <div class="template__content">
      <div class="row">
        <div class="col-12">
          <h1>Nos formations | <span class="marker-effect">Français pour réfugiés</span></h1>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mt-4">
          <div class="col p-0">
            <h5>Français à visée A2 pour réfugiés</h5>
            <span>Action BOP104-Action 12</span>
          </div>
          <div class="row">
            <div class="font-bold">Public et prérequis</div>
            Bénéficiaires de la protection internationale peu scolarisés dans leur pays d'origine,
            ayant déjà effectué le parcours OFII.
          </div>
          <div class="row">
            <div class="font-bold">Objectifs</div>
            Poursuivre et renforcer l'apprentissage du français écrit et oral, apprendre à communiquer
            autour des thèmes de la vie quotidienne, acquérir les bases de grammaire attendues au
            niveau A2
          </div>

          <div class="row">
            <div class="font-bold">Taux de satisfaction</div>
              Taux de satisfaction sur la qualité de nos formations 91% <br>
              Taux de satisfaction sur la relation avec les formateurs 99%
          </div>

          <div class="row mt-5">
            <img
              src="@/assets/images/05-alpha-2.jpeg"
              style="max-width: 600px"
              alt="cour de francais visee pro"
            />
          </div>

          <div class="row mt-5">
            <h6>Descriptions des cours</h6>

            Action en partenariat avec l’association FLE et Compagnie composée de 9h de cours
            hebdomadaires, d’atelier de conversation et d’informatique (4h/semaine) et de sorties
            culturelles.
            <ul>
              <li>
                <span class="font-semibold">Horaires :</span> lundi, mercredi, vendredi de 10h à 13h
                et mardi, jeudi de 10h à 12h
              </li>
              <li><span class="font-semibold">Tarif :</span> gratuit</li>
              <li>
                <span class="font-semibold">Durée, volume horaire :</span> octobre à mai (351h)
              </li>
              <li>
                <span class="font-semibold">Lieu du cours :</span> Association Femmes Initiatives
              </li>
              <li>
                <span class="font-semibold">Les modalités d’inscription:</span>
                <router-link to="contact">nous contacter</router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 text-center">
          <a href="/francais_pour_refugies.pdf" download>Télécharger la plaquette</a>
        </div>
      </div>
    </div>
  </div>
</template>
